'use client';

import { Box } from '@mui/material';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksFaqList,
  ComponentBlocksQuestionList,
  Enum_Componentshareddisplayoptions_Contentswidth,
} from '@/types';

import GlobalBlockRenderer from '../GlobalBlockRenderer/GlobalBlockRenderer';
import { FaqListPlain } from './FaqListPlain';
import { FaqListWithGrouping } from './FaqListWithGrouping';
import { QuestionAnswer } from './QuestionAnswer';

export function FaqList({ props }: { props: ComponentBlocksFaqList }) {
  if (props.Variant === 'WithGrouping') {
    return <FaqListWithGrouping props={props} />;
  }

  if (!props.FaqListStyle || props.FaqListStyle === 'Plain') {
    return <FaqListPlain props={props} />;
  }

  return (
    <CustomBackground
      backgroundOptions={(props?.FaqListBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        {
          ...props?.FaqListDisplayOptions,
          ContentsWidth:
            props?.FaqListDisplayOptions?.ContentsWidth ??
            Enum_Componentshareddisplayoptions_Contentswidth.Wide,

          PaddingTop: props?.FaqListDisplayOptions?.PaddingTop ?? 'md',
          PaddingBottom: props?.FaqListDisplayOptions?.PaddingBottom ?? 'md',
          PaddingInline: props?.FaqListDisplayOptions?.PaddingInline ?? 'md',
        } as StrapiDisplayOptions
      }
      boxProps={{
        // @ts-expect-error - this does work, but types are not correct
        'data-component': 'FaqList',
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          textAlign: 'center',
          mb: 6,
          h2: {
            textAlign: 'center',
          },
        }}
      >
        <GlobalBlockRenderer content={props.Body || []} forceHeadingLevel={2} />
      </Box>
      <Box
        sx={{
          '& > *': {
            '&:nth-of-type(even)': {
              ml: { xs: 3, sm: 6, md: 8 },
            },
            '&:nth-of-type(odd)': {
              mr: { xs: 3, sm: 6, md: 8 },
            },
          },
        }}
      >
        {props.Questions?.map((q) => (
          <QuestionAnswer key={`${q?.id}-${q?.Question}`} {...(q as ComponentBlocksQuestionList)} />
        ))}
      </Box>
    </CustomBackground>
  );
}
